import TIM from 'tim-js-sdk'
import {
  getSig,
  getLiveRoomInfo,
  askQuestion,
  deleteQuestion,
  getQuestionList,
  getMyQuestionList,
  getNumberOfMyWaitingQuesiont,
  getMyQuestionRanking,
  saveUserHistory,
  getQuestionStatusNumber
} from '@/api/livingRoom'
import TimEventBus from '../TimEventBus'

const TIM_CUSTOM_SYSTEM_TYPES = {
  LIVE_ROOM_END: 'liveroomEnd', // 直播结束
  MUTE_ALL: 'shutUpAllMember', // 全局禁言的系统消息类型
  FORBID_SOMEONE: 'forbidSendMsg', // 某人被禁言了
  QESTION_SWITCH: 'liveroomAnswerSwitchChange', // 开关用户提问
  QUESTION_ADDED: 'liveroomUserQuestionAdded', // 新增用户提问
  QUESTION_REFUESED: 'liveroomQueueRefused', // 用户提问被打回的事件类型
  QUESTION_EXPLAIN_START: 'liveroomQueueStartExplain', // 开始讲解用户提问事件类型
  QUESTION_EXPLAIN_COMPLETE: 'liveroomQueueExplainComplete', // 完成讲解事件类型
  MESSAGE_DELETED: 'liveroomChatContentDelete', // 消息删除
  startQuestionBank: 'startQuestionBank', // 开始答题
  endQuestionBank: 'endQuestionBank' // 结束答题
}

/**
 * 直播间
 */
export default {
  namespaced: true,
  state: {
    id: null, // 直播id，也是IM直播群id
    profile: {
      nick: null,
      avatar: null,
      gender: null,
      selfSignature: null,
      allowType: null
    },
    questionBoard: {
      number: 0,
      ranking: 0
    },
    room: {
      name: '',
      cover: null, // 直播间封面链接
      liveStatus: 0, // 注意根据不同直播状态的处理
      playUrl: null, // 直播播流地址m3u8地址
      playUrlMap: {},
      imAppid: null, // 腾讯云IM应用appid
      muteAll: true, // 是否全体被禁言
      forbid: false, // 用户是否被禁言
      tipTopRefused: '', // 首页顶部轮播
      tipTopNoticeAnswering: '',
      switchQuestion: false, // 是否可以提问
      svipQuestionComeIn: false, // vip问题空降
      timerSvipQuestionComeIn: null,
      answerUserScope: 'sv',
      liveEnded: false
    },
    messages: [], // 直播间的消息列表
    tim: null, // tim实例
    followStatus: false, // 用户是否关注了平台
    isReady: false,
    haveNoAnsweredQeustion: false, // 用户是否发起过提问
    timer001: null // SVIP_QUESTION_COME_IN
  },
  // mutations 修改器，用于修改state中的定义的状态变量,同步
  mutations: {
    UPDATE_STATUS_ASKED_QUESTION(state, bool) {
      state.haveNoAnsweredQeustion = bool
    },
    UPDATE_QUESTION_BOARD_NUMBER(state, { ranking, number }) {
      state.questionBoard.number = number
      state.questionBoard.ranking = ranking <= 0 ? 0 : ranking
    },
    DELETE_QUESTION_BY_ID(state, id) {
      state.question.list = state.question.list.filter((q) => q.id !== id)
      state.question.mine = state.question.mine.filter((q) => q.id !== id)
    },
    SET_SWITCH_QUESTION(state, bool) {
      state.room.switchQuestion = bool
    },
    SET_MUTE_ALL(state, muteAll) {
      state.room.muteAll = muteAll
    },
    SET_FORBID(state, bool) {
      state.room.forbid = bool
    },
    SET_TIP_TOP_ANSWERING(state, text) {
      state.room.tipTopNoticeAnswering = text
    },
    SET_TIP_TOP_QUESTION_REFUSED(state, text) {
      state.room.tipTopRefused = text
      setTimeout(() => {
        state.room.tipTopRefused = ''
      }, 15000)
    },
    SVIP_QUESTION_COME_IN(state) {
      let time = 5000
      if (state.timer001) {
        time += 500
        clearTimeout(state.timer001)
        state.room.svipQuestionComeIn = false
        setTimeout(() => {
          state.room.svipQuestionComeIn = true
        }, 500)
      } else {
        state.room.svipQuestionComeIn = true
      }
      state.timer001 = setTimeout(() => {
        state.room.svipQuestionComeIn = false
      }, time)
    },
    PUSH_MESSAGE(state, message) {
      state.messages.push({
        id: message.ID,
        avatar: message.avatar,
        nick: message.nick,
        text: message.payload.text
      })
    },
    UPDATE_PROFILE(state, profile) {
      for (const key in profile) {
        if (profile[key]) {
          state.profile[key] = profile[key]
        }
      }
    },
    // 接收用户进入群组的群组资料
    SET_DATA_GROUP_LOGINED(state, group) {
      const { muteAllMembers } = group
      state.room.muteAll = muteAllMembers === 'On'
    },
    TIM_READY(state) {
      state.isReady = true
    },
    SET_TIM(state, tim) {
      state.tim = tim
    },
    SET_LIVE_ROOM_ID(state, id) {
      state.id = id
    },
    SET_ROOM_DATA(state, payload) {
      for (const key in payload) {
        if (payload[key]) {
          state.room[key] = payload[key]
        }
      }
    },
    LIVE_END(state) {
      state.room.liveEnded = true
    },
    MESSAGE_DELETE_ONE_BY_ID(state, messageTimId) {
      messageTimId = messageTimId.slice(0, -1) // id的最后一位是 -0 是自己发送的 -1 是其它人
      state.messages = state.messages.filter((msg) => msg.id.indexOf(messageTimId) === -1)
    }
  },
  // 存放异步操作，由 action 去触发 mutation
  actions: {
    /**
     * 更新TIM的个人资料 https://imsdk-1252463788.file.myqcloud.com/IM_DOC/Web/SDK.html#updateMyProfile
     * @param {*} param0
     * @params {Object} profile
     *  @property {String} nick
     *  @property {String} avatar
     *  @property {TIM.TYPES} gender
     *  @property {Sring} selfSignature
     *  @property {TIM.TYPES} allowType
     * @return {Promise} resolve => res.data
     */
    async updateTIMProfile({ state, commit }, profile) {
      console.warn('提交给TIM个人资料前', profile)
      const { tim } = state
      return tim
        .updateMyProfile({
          ...profile
        })
        .then((imResponse) => {
          console.warn('提交TIM个人资料结果', imResponse)
          commit('UPDATE_PROFILE', profile) // 更新本地数据
          return
        })
    },
    // 发送消息
    async sendMessage({ state, commit }, text) {
      const { tim, id, profile } = state
      try {
        const imResponse = await tim.sendMessage(
          tim.createTextMessage({
            to: id,
            conversationType: TIM.TYPES.CONV_GROUP,
            // 消息优先级，用于群聊（v2.4.2起支持）。如果某个群的消息超过了频率限制，后台会优先下发高优先级的消息，详细请参考：https://cloud.tencent.com/document/product/269/3663#.E6.B6.88.E6.81.AF.E4.BC.98.E5.85.88.E7.BA.A7.E4.B8.8E.E9.A2.91.E7.8E.87.E6.8E.A7.E5.88.B6)
            // 支持的枚举值：TIM.TYPES.MSG_PRIORITY_HIGH, TIM.TYPES.MSG_PRIORITY_NORMAL（默认）, TIM.TYPES.MSG_PRIORITY_LOW, TIM.TYPES.MSG_PRIORITY_LOWEST
            // priority: TIM.TYPES.MSG_PRIORITY_NORMAL,
            payload: {
              text: text
            }
          })
        )
        commit('PUSH_MESSAGE', {
          ...imResponse.data.message,
          ...profile
        })
      } catch (e) {
        if (e.code === 10017) {
          commit('SET_FORBID', true)
        }
      }
    },
    async initLiveRoomInfo({ dispatch, commit }, { liveRoomId, SDKAppID }) {
      try {
        commit('SET_LIVE_ROOM_ID', `${liveRoomId}`)
        commit
        // 1. 创建tim实例
        await dispatch('initTIM', { SDKAppID })
        // 2. 用openid登陆TIM的群组
        await dispatch('loginTIM', `${liveRoomId}`)
      } catch (e) {
        console.log(e)
      }
    },
    /**
     * 收到文本消息
     * @param {*} param0 vuex
     * @param {*} message TIM MESSAGE 对象
     */
    handleTIMTextMsgRecived({ commit }, message) {
      commit('PUSH_MESSAGE', message)
      // 详细数据结构请参考 TextPayload 接口的说明
    },
    /**
     * 收到自定义消息
     */
    handleTIMCustomMsgRecived({ commit }, message) {},
    handleTIMGrpoupTipRecived({ commit }, message) {},
    /**
     * 收到系统消息
     */
    handleTIMGroupSystemNoticeRecived({ rootGetters, commit, dispatch }, message) {
      const { openid } = rootGetters
      // 详细数据结构请参考  GroupSystemNoticePayload 接口的说明
      const payload = JSON.parse(message.payload.userDefinedField)
      switch (payload.type) {
        // 某人的消息被删除
        case TIM_CUSTOM_SYSTEM_TYPES.MESSAGE_DELETED: {
          payload.data.forEach((msg) => {
            commit('MESSAGE_DELETE_ONE_BY_ID', msg.im_id)
          })
          break
        }
        // 直播结束
        case TIM_CUSTOM_SYSTEM_TYPES.LIVE_ROOM_END: {
          commit('LIVE_END')
          commit('SET_FORBID', true)
          commit('SET_SWITCH_QUESTION', false)
          break
        }
        // 有人被禁言了
        case TIM_CUSTOM_SYSTEM_TYPES.FORBID_SOMEONE: {
          if (payload.openidList.indexOf(openid) >= 0 && payload.ShutUpTime !== 0) {
            commit('SET_FORBID', true)
          } else {
            commit('SET_FORBID', false)
          }
          break
        }
        //  全局禁言/解除全局
        case TIM_CUSTOM_SYSTEM_TYPES.MUTE_ALL: {
          commit('SET_MUTE_ALL', payload.ShutUpAllMember === 'on')
          break
        }
        // 允许提问/禁止提问
        case TIM_CUSTOM_SYSTEM_TYPES.QESTION_SWITCH: {
          commit('SET_SWITCH_QUESTION', payload.status === 'on')
          break
        }
        // 提问（SVIP空降、刷新数量）
        case TIM_CUSTOM_SYSTEM_TYPES.QUESTION_ADDED: {
          if (payload.data.userLevel === 'sv') {
            commit('SVIP_QUESTION_COME_IN')
          }
          dispatch('updateQuestionQuenueNumber')
          break
        }
        // 有用户的提问被打回
        case TIM_CUSTOM_SYSTEM_TYPES.QUESTION_REFUESED: {
          const question = payload.data.questions.find((i) => i.openid === openid)
          if (question) {
            commit(
              'SET_TIP_TOP_QUESTION_REFUSED',
              `用户${question.nick}的提问被打回~&nbsp;&nbsp;&nbsp;&nbsp&nbsp;`
            )
          }
          dispatch('updateQuestionQuenueNumber')
          break
        }
        // 开始解答问题，顶部轮播
        case TIM_CUSTOM_SYSTEM_TYPES.QUESTION_EXPLAIN_START: {
          const question = payload.data.questions.find((i) => i.openid === openid)
          if (question) {
            if (question.userLevel !== 'nv') {
              commit(
                'SET_TIP_TOP_ANSWERING',
                `正在讲解<b style="color:#FAFF00">【SVIP】</b>用户${question.nick}提问，请认真听讲哦~&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;`
              )
            } else {
              commit(
                'SET_TIP_TOP_ANSWERING',
                `正在讲解用户${question.nick}提问，请认真听讲哦~&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;`
              )
            }
          }
          break
        }
        // 结束回答
        case TIM_CUSTOM_SYSTEM_TYPES.QUESTION_EXPLAIN_COMPLETE: {
          dispatch('updateQuestionQuenueNumber')
          commit('SET_TIP_TOP_ANSWERING', '')
          break
        }
        // 开始答题
        case TIM_CUSTOM_SYSTEM_TYPES.startQuestionBank: {
          dispatch('answerQues/dispatch_TIMEVENT_startQuestionBank', payload, { root: true })
          break
        }
        // 结束答题
        case TIM_CUSTOM_SYSTEM_TYPES.endQuestionBank: {
          dispatch('answerQues/dispatch_TIMEVENT_endQuestionBank', payload, { root: true })
          break
        }
        default:
          break
      }
    },
    /**
     *
     */
    async handleTIMReady({ commit, dispatch, rootGetters }, event) {
      const { wechatUserInfo } = rootGetters
      if (wechatUserInfo.nickname && wechatUserInfo.headimgurl) {
        dispatch('updateTIMProfile', {
          nick: wechatUserInfo.nickname,
          avatar: wechatUserInfo.headimgurl
        })
      }
      commit('TIM_READY')
    },
    async loginTIM({ dispatch, state, commit, rootGetters }, groupID) {
      const tim = state.tim
      const { openid } = rootGetters
      const { userSig } = await getSig(openid).then((res) => res.data.data)
      await tim.login({ userID: openid, userSig })
      /**
       * imResponse.data.status:
       *  TIM.TYPES.JOIN_STATUS_SUCCESS // 加群成功 ->  imResponse.data.group // 加入的群组资料
       *  TIM.TYPES.JOIN_STATUS_ALREADY_IN_GROUP // 已经在群中
       */
      const imResponse = await tim.joinGroup({ groupID })
      switch (imResponse.data.status) {
        case TIM.TYPES.JOIN_STATUS_SUCCESS:
          commit('SET_DATA_GROUP_LOGINED', imResponse.data.group)
          break
        case TIM.TYPES.JOIN_STATUS_ALREADY_IN_GROUP:
          break
        default:
          break
      }
    },
    // 初始化TIM
    initTIM({ commit, dispatch }, { SDKAppID }) {
      TimEventBus.$on('SDK_READY', () => {
        dispatch('handleTIMReady')
      })
      // 聊天消息
      TimEventBus.$on('MSG_TEXT', (message) => {
        dispatch('handleTIMTextMsgRecived', message)
      })
      // 系统化消息
      TimEventBus.$on('MSG_GRP_SYS_NOTICE', (message) => {
        dispatch('handleTIMGroupSystemNoticeRecived', message)
      })
      const tim = TimEventBus.initTim(SDKAppID)
      commit('SET_TIM', tim)
      return tim
    },
    /**
     * 获取直播间的信息
     */
    async requestLiveRoomInfo({ commit }, roomId) {
      const { data } = await getLiveRoomInfo(roomId).then((res) => res)
      const payload = {
        name: data.name,
        cover: data.cover,
        liveStatus: data.liveStatus,
        playUrl: data.playUrl,
        imAppid: data.imAppid,
        playUrlMap: data.playUrlMap,
        answerUserScope: data.answerUserScope
      }
      commit('SET_SWITCH_QUESTION', data.answerSwitch === 1)
      commit('SET_ROOM_DATA', payload)
      return payload
    },
    /**
     * ********************* 提问 ******************
     */
    // 查询自己是否有带解答问题
    async isHaveNoAnsweredQeustion({ rootGetters, state, commit }) {
      const { openid, appid } = rootGetters
      const { id } = state
      const { status, data } = await getMyQuestionRanking(
        {
          roomId: id,
          openid,
          appid
        },
        true
      )
      if (status) {
        commit('UPDATE_STATUS_ASKED_QUESTION', data > -1)
      }
      return {
        status,
        data
      }
    },
    // 获取问题排行
    async updateQuestionQuenueNumber({ rootGetters, state, commit }) {
      const { openid, appid } = rootGetters
      const { id, haveNoAnsweredQeustion } = state

      const [number, ranking] = await Promise.all([
        getNumberOfMyWaitingQuesiont({
          roomId: id,
          openid,
          appid
        }),
        getMyQuestionRanking(
          {
            roomId: id,
            openid,
            appid
          },
          haveNoAnsweredQeustion
        )
      ]).then(([resNumber, resRanking]) => {
        if (haveNoAnsweredQeustion) {
          return [resNumber.data, resRanking.data - 1]
        }
        return [resNumber.data, resRanking.data]
      })

      commit('UPDATE_QUESTION_BOARD_NUMBER', {
        ranking,
        number
      })
      return {
        ranking,
        number
      }
    },
    // 获取问题列表
    async requestRoomQuestionList({ commit, state }, { page, size = 5 }) {
      const { id } = state
      const { status, data, msg } = await getQuestionList({
        search_EQ_liveroomId: id,
        page: page,
        size
      }).then((res) => res.data)
      return {
        status,
        data,
        msg
      }
    },
    // 获取我的问题列表
    async requestMineQuestionList({ commit, state, rootGetters }, { page, size = 5 }) {
      const { openid, appid } = rootGetters
      const { id } = state
      const { status, data, msg } = await getMyQuestionList({
        search_EQ_liveroomId: id,
        search_EQ_openid: openid,
        search_EQ_appid: appid,
        page: page,
        size
      }).then((res) => res.data)
      return {
        status,
        data,
        msg
      }
    },
    // 删除提问
    async deleteQuestionById({ commit, rootGetters }, id) {
      const { openid, appid } = rootGetters
      const { status, msg } = await deleteQuestion({
        appid,
        openid,
        id
      })
      if (status === 200) {
        commit('DELETE_QUESTION_BY_ID', id)
      }
      return {
        status,
        message: msg
      }
    },
    // 发起提问
    async askQuestion(
      { rootGetters, state, commit },
      { questionImg, questionDesc, source = 'user', sourceId }
    ) {
      const { id } = state
      const { nick, avatar } = state.profile
      const { openid, appid, vip, subscribe } = rootGetters
      const body = {
        appid,
        openid,
        questionImg,
        userLevel: vip,
        nick,
        avatar,
        source,
        liveroomId: id,
        questionDesc,
        followStatus: subscribe
      }
      if (source === 'book') {
        body.sourceId = sourceId
      }
      const { status, msg, data } = await askQuestion(body).then((res) => res.data)
      if (status === 200) {
        commit('UPDATE_STATUS_ASKED_QUESTION', true)
      }
      return {
        status,
        data,
        message: msg
      }
    },
    // 获取问题排行
    async getQuestionStatusNumber({ rootGetters, state, commit }) {
      const { openid, appid } = rootGetters
      const { id } = state
      const { status, data } = await getQuestionStatusNumber({
        roomId: id,
        openid,
        appid
      })
      return {
        status,
        data
      }
    },
    // 获取我的所有提问
    async requestAllMineQuestionList({ rootGetters }, { page, size = 5, solutionState }) {
      const { openid, appid } = rootGetters
      const { status, data, msg } = await getMyQuestionList({
        search_EQ_openid: openid,
        search_EQ_appid: appid,
        search_EQ_solutionState: solutionState,
        page: page,
        size,
        sort: 'createTime,desc'
      }).then((res) => res.data)
      return {
        status,
        data,
        msg
      }
    },

    /**
     * ***************** 统计 *********************
     */
    // 保存用户浏览直播间日志
    async saveUserHistory({ rootGetters, state }, { comeFrom }) {
      const { id } = state
      const { openid, appid, vip, wechatUserInfo } = rootGetters
      const { status, msg, data } = await saveUserHistory({
        appid,
        openid,
        userLevel: vip,
        nick: wechatUserInfo.nickname,
        avatar: wechatUserInfo.headimgurl,
        liveroomId: id,
        comeFrom: comeFrom || '1' // 标识从哪里跳转到直播间的
      })
      return {
        status,
        data,
        message: msg
      }
    }
  },
  getters: {
    messages: (state) => state.messages,
    tim: (state) => state.tim,
    questionBoard: (state) => state.questionBoard,
    haveNoAnsweredQeustion: (state) => state.haveNoAnsweredQeustion,
    room: (state) => state.room,
    mute: (state) => state.room.muteAll || state.room.forbid,
    tipTop: (state) => {
      return state.room.tipTopNoticeAnswering + state.room.tipTopRefused
    }
  }
}
